/** i18n keys for the organisation CSP domain whitelist section (GR-3612). */
const ROOT = 'template.organisation.content.csp-domains';

export const i18nKeys = {
  HEADER: `${ROOT}.header`,
  INFO_HEADER: `${ROOT}.info.header`,
  INFO_CONTENT: `${ROOT}.info.content`,
  INFO_CONTENT_CAMPAIGN: `${ROOT}.info.content-campaign`,
  EMPTY: `${ROOT}.empty`,
  INPUT_PLACEHOLDER: `${ROOT}.input-placeholder`,
  ADD_BUTTON: `${ROOT}.add-button`,
  SAVE_BUTTON: `${ROOT}.save-button`,
  CANCEL_BUTTON: `${ROOT}.cancel-button`,
  REMOVE_BUTTON: `${ROOT}.remove-button`,
  INHERITED_HEADER: `${ROOT}.inherited.header`,
  INHERITED_CONTENT: `${ROOT}.inherited.content`,
  ERROR_INVALID: `${ROOT}.errors.invalid`
} as const;
